import { render, staticRenderFns } from "./speaker-card.vue?vue&type=template&id=5003b55c&scoped=true"
import script from "./speaker-card.vue?vue&type=script&lang=js"
export * from "./speaker-card.vue?vue&type=script&lang=js"
import style0 from "./speaker-card.vue?vue&type=style&index=0&id=5003b55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003b55c",
  null
  
)

export default component.exports